import React from 'react';
import { Link } from 'react-router-dom';

import {
  Breadcrumb, Row, Col, Card, Button,
} from 'antd';
import { useTranslation } from 'react-i18next';
import MainLayout from '@common/layouts/MainLayout';
import { SaveOutlined } from '@ant-design/icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrochip, faSearch } from '@fortawesome/free-solid-svg-icons';

import DeviceData from './containers/DeviceData/DeviceData';
import StateBateryChart from './containers/StateBateryChart/StateBateryChart';
import BatterySoc from './containers/BatterySoc/BatterySoc';
import ConsultGraph from './containers/ConsultGraph/ConsultGraph';
import TableNotification from './containers/TableNotification/TableNotification';
import EnergyData from './containers/EnergyData/EnergyData';
import SystemStatus from './containers/SystemStatus/SystemStatus';

import useGraficasDispositivo from './useGraficasDispositivo';
import styles from './GraficasDispositivo.module.less';

import styles1 from './GraficasDispositivoVariable.module.less';

function GraficasDispositivo() {

  const { t } = useTranslation();
  const {
    device,
    dataDevice,
    BreadcrumbTitle,
    handleDeviceHome,
    dataBusinessType
  } = useGraficasDispositivo();

  return (
    <>
      <MainLayout applyPadding={false}>
        {/*<div className={styles.wrapperBreadcrumb}>
          <Card style={{ width: '100%' }}>
            <Row>
              <Col
                xs={{
                  span: 24,
                }}
                sm={{
                  span: 24,
                }}
                md={{
                  span: 20,
                }}
                lg={{
                  span: 20,
                }}
                xl={{
                  span: 20,
                }}
              >
                <div className={styles.section_title}>{t('views.device_graphics.view_detail')}</div>

                <Breadcrumb className={styles.date_wrapper}>
                  <Breadcrumb.Item className={styles.breadcrumb}>
                    <Link to="/tablero-general">{BreadcrumbTitle}</Link>
                  </Breadcrumb.Item>

                  <Breadcrumb.Item className={styles.breadcrumb}>
                    <a onClick={handleDeviceHome}>
                      {dataDevice && dataDevice.business || 'Business'}
                    </a>
                  </Breadcrumb.Item>

                  <Breadcrumb.Item className={styles.breadcrumb}>
                    {device || t('menu_items.main.devices')}
                  </Breadcrumb.Item>
                </Breadcrumb>

              </Col>
            </Row>
          </Card>
              </div>*/}

        <div className={styles.wrapper}>
          <div className={styles.column}>

            {/*<DeviceData />*/}
             <Card className="shadows" style={{ width: '100%' }}>
                <Row gutter={[16, 8]} style={{ fontSize: 20, fontWeight: 'bold', marginBottom: 10 }}>
                  <Col
                    xs={{
                      span: 5,
                    }}
                    sm={{
                      span: 4,
                    }}
                    md={{
                      span: 3,
                    }}
                    lg={{
                      span: 2,
                    }}
                    xl={{
                      span: 2,
                    }}
                    className="text-center"
                    style={{ color: '#8c8c8c', fontSize: 24, fontWeight: 'bold' }}
                  >
                    <div className={styles1.circle_icon_container}>
                      {dataBusinessType?.logo_full_url && dataBusinessType?.logo_full_url !== ''
                        ? (
                          <img
                            src={dataBusinessType?.logo_full_url}
                            alt={dataBusinessType?.name}
                            className="image-logo-busines-detail"
                          />
                        )
                        : (
                          <FontAwesomeIcon icon={faMicrochip} style={{ fontSize: 20, color: '#ffffff' }} />
                        )}
                    </div>
                  </Col>
                  <Col
                    xs={{
                      span: 19,
                    }}
                    sm={{
                      span: 20,
                    }}
                    md={{
                      span: 21,
                    }}
                    lg={{
                      span: 22,
                    }}
                    xl={{
                      span: 22,
                    }}
                  >
                    <Row style={{ color: '#8c8c8c', fontSize: 24, fontWeight: 'bold' }}>
                      {dataDevice && dataDevice.name ? dataDevice.name : (device || 'Device')}
                    </Row>
                    <Row style={{ fontSize: '14px', color: '#8c8c8c' }}>

                      <Breadcrumb className={styles1.date_wrapper}>
                        <Breadcrumb.Item className={styles1.breadcrumb}>
                          <Link to="/tablero-general">{BreadcrumbTitle}</Link>
                        </Breadcrumb.Item>

                        <Breadcrumb.Item className={styles1.breadcrumb}>
                          <a onClick={handleDeviceHome}>
                            {dataBusinessType && dataBusinessType.name || 'Business'}
                          </a>
                        </Breadcrumb.Item>

                        <Breadcrumb.Item className={styles1.breadcrumb}>
                          {dataDevice && dataDevice.name || t('menu_items.main.devices')}
                        </Breadcrumb.Item>
                      </Breadcrumb>

                    </Row>
                  </Col>
                </Row>
                <Row>
                  <DeviceData />
                </Row>
            </Card>

            <SystemStatus />
            <ConsultGraph />

          </div>
          <div className={styles.column}>

            <EnergyData />
            <BatterySoc />
            <StateBateryChart />
          </div>
        </div>
      </MainLayout>
    </>
  );

}

export default GraficasDispositivo;
